import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";

export const createGetPlaceHandler = (onRequest?: () => void) => [
  http.get(`**${apiPaths.places.getPlace}`, ({ request }) => {
    onRequest?.();
    const url = new URL(request.url);
    const placeId = url.pathname.split("/").pop();

    // Handle hotel place IDs (H prefix)
    if (placeId?.startsWith("H")) {
      return HttpResponse.json(
        {
          place: {
            id: placeId,
            name: "Andaz 5th Avenue",
            type: "Hotel",
            label: "New York, New York 10017, New York, New York, United States of America",
          },
        },
        { status: 200 },
      );
    }

    // Handle non-hotel place IDs (default to New York city)
    return HttpResponse.json(
      {
        place: {
          id: "R2621",
          name: "New York",
          type: "City",
          label: "New York, New York, United States of America",
          latitude: 40.712843,
          longitude: -74.005966,
        },
      },
      { status: 200 },
    );
  }),
];

const getPlaceHandlers = createGetPlaceHandler();
const findPlacesHandlers = [
  http.get(`**${apiPaths.places.findPlaces}`, () => {
    return HttpResponse.json(
      {
        places: [
          {
            id: "H125866",
            name: "Andaz 5th Avenue",
            type: "Hotel",
            label: "New York, New York 10017, New York, New York, United States of America",
          },
          {
            id: "R2621",
            name: "New York",
            type: "City",
            label: "New York, New York, United States of America",
          },
          {
            id: "R502103",
            name: "New York University",
            type: "PointOfInterest",
            label: "New York University, New York, New York, United States of America",
          },
          {
            id: "R553248621533127453",
            name: "New York Theatre Workshop",
            type: "PointOfInterest",
            label: "New York Theatre Workshop, New York, New York, United States of America",
          },
          {
            id: "R553248621533117265",
            name: "New York Earth Room",
            type: "PointOfInterest",
            label: "New York Earth Room, New York, New York, United States of America",
          },
          {
            id: "R553248621533117481",
            name: "New York Times Building",
            type: "PointOfInterest",
            label: "New York Times Building, New York, New York, United States of America",
          },
          {
            id: "R6065057",
            name: "New York City Fire Museum",
            type: "PointOfInterest",
            label: "New York City Fire Museum, New York, New York, United States of America",
          },
          {
            id: "R502067",
            name: "New York Public Library",
            type: "PointOfInterest",
            label: "New York Public Library, New York, New York, United States of America",
          },
          {
            id: "R624555039643611136",
            name: "New York Presbyterian Hospital",
            type: "PointOfInterest",
            label: "New York Presbyterian Hospital, New York, New York County, New York, United States of America",
          },
          {
            id: "R6064561",
            name: "New York Historical Society",
            type: "PointOfInterest",
            label: "New York Historical Society, New York, New York, United States of America",
          },
          {
            id: "R553248621561874240",
            name: "New York Convention and Visitors Bureau",
            type: "PointOfInterest",
            label: "New York Convention and Visitors Bureau, New York, New York, United States of America",
          },
        ],
      },
      { status: 200 },
    );
  }),
];
export const placesHandlers = {
  getPlace: getPlaceHandlers,
  findPlaces: findPlacesHandlers,
} as const;
